<script lang="ts">
  import { onMount } from "svelte";
  import { stagedRolloutCheck } from "@shared/svelte/Modules/StagedRolloutCheck.svelte";

  // components
  import CreditsBanner from "@retailer/svelte/Payments/Banners/Credits.svelte";

  // services
  import * as UserNotificationsService from "@retailer/services/user_notifications_service";

  // stores
  import { userNotifications } from "@retailer/stores/UserNotificationsStore";
  import { creditsStore } from "@retailer/stores/CreditsStore";

  // data
  let specsReadOnly = stagedRolloutCheck("specs_read_only_payments");
  const creditsBannerType = "credits_banner";

  // functions
  const createUserNotification = async type => {
    const data = {
      user_notification: {
        notification_type: type,
        seen_at: new Date(),
        retailer_id: window["$rootScope"].currentRetailerId,
      },
    };

    return await UserNotificationsService.create(data);
  };
  const handleBannerClose = async type => {
    switch (type) {
      case creditsBannerType:
        showCreditsBanner = false;
        break;
    }
    await createUserNotification(type);
  };
  const userNotificationSeen = type =>
    $userNotifications.seen.find(n => n.notification_type == type);

  onMount(() => {
    UserNotificationsService.getNotifications();
  });

  // reactives
  $: showLoadingState = !$creditsStore.loaded;
  $: showCreditsBanner =
    !userNotificationSeen(creditsBannerType) && !showLoadingState && !specsReadOnly;

</script>

{#if showCreditsBanner}
  <CreditsBanner {handleBannerClose} />
{/if}
